import { Fragment, useContext } from "react";

import { useTranslation } from "react-i18next";

import { FMX } from "components/Actions/dialogs/DeviceGroups/ManageGroup/content/AddFiles/constants";
import CardItemValue from "components/TableDetails/components/CardItemValue";
import { TitleInfo } from "components/TableDetails/components/TitleInfo";
import { renderAvailableData } from "components/TableDetails/functions";
import TableContext from "context/table/tableContext";
import { FILE_TYPES } from "shared";

import { FMX_PLATFORM_FILES } from "../constants";
import { DeviceGroupDetailsData } from "../types";

const FmxPlatformFiles = () => {
    const { detailsData } = useContext(TableContext);

    const { t } = useTranslation();

    const { configuration, firmware }: DeviceGroupDetailsData = detailsData;

    const list = [
        {
            title: FILE_TYPES.Firmware,
            value: firmware?.name,
            isAvailable: true
        },
        {
            title: FILE_TYPES.Configuration,
            value: configuration?.name,
            isAvailable: true
        }
    ];

    return (
        <div>
            <div>
                {t("Dialog##smart group##title", {
                    platformName: FMX
                })}

                <TitleInfo
                    aria-label={t("Dialog##smart group##title", {
                        platformName: FMX
                    })}
                    cardName={FMX_PLATFORM_FILES}
                    list={list}
                />
            </div>

            <div>
                {renderAvailableData(list).map(({ title, value }) => {
                    return (
                        <Fragment key={title}>
                            <span>{t(`General##${title}`)}:</span>
                            <CardItemValue value={value} />
                        </Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export { FmxPlatformFiles };
